import { render, staticRenderFns } from "./SendMassCustomNotification.vue?vue&type=template&id=3db490d0&scoped=true"
import script from "./SendMassCustomNotification.vue?vue&type=script&lang=js"
export * from "./SendMassCustomNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db490d0",
  null
  
)

export default component.exports